import type {
  BulkApproveProgress,
  PendingPayment,
  PendingPaymentDetails,
} from 'src/interfaces/paymentsReview'
import type { State } from '../reducers/types'

export const getPendingPayments = (state: State): PendingPayment[] => {
  return state.paymentsReview.pending
}

export const getPendingPaymentsLoading = (state: State): boolean => {
  return state.paymentsReview.pendingLoading
}

export const getPendingPaymentsError = (state: State): string | null => {
  return state.paymentsReview.pendingError
}

export const getPendingPaymentDetails = (state: State): PendingPaymentDetails | null => {
  return state.paymentsReview.details
}

export const getPendingPaymentDetailsLoading = (state: State): boolean => {
  return state.paymentsReview.detailsLoading
}

export const getPendingPaymentDetailsError = (state: State): string | null => {
  return state.paymentsReview.detailsError
}

export const getPaymentReviewSubmitting = (state: State): boolean => {
  return state.paymentsReview.submitting
}

export const getBulkApproveProgress = (state: State): BulkApproveProgress | null => {
  return state.paymentsReview.bulkProgress
}
